/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Duration_RangeInputs */

const en_exp_duration_range = /** @type {(inputs: Exp_Duration_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed at 30 TSS per hour of activity.`)
};

const de_exp_duration_range = /** @type {(inputs: Exp_Duration_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fest bei 30 TSS pro Stunde.`)
};

/**
* | output |
* | --- |
* | "Fixed at 30 TSS per hour of activity." |
*
* @param {Exp_Duration_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_duration_range = /** @type {((inputs?: Exp_Duration_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Duration_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_duration_range(inputs)
	return de_exp_duration_range(inputs)
});